import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../list/actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import store from '../../../../store';

function* removeBatchMessageTemplate({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.sendbird.templates.remove, id });

    dispatch(listActions.batchMessageTemplatesSetPage(1));
    if (getState().getBatchMessageTemplates.curr_page === 1) dispatch(listActions.getBatchMessageTemplatesRequest({ curr_page: 1 }));

    onSuccess && onSuccess();
    yield put(actions.removeBatchMessageTemplateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.removeBatchMessageTemplateFailed,
      endpoint: api.sendbird.templates.remove.url
    });
  }
}

export const removeBatchMessageTemplateSaga = takeEvery(types.REMOVE_BATCH_MESSAGE_TEMPLATE_REQUEST, removeBatchMessageTemplate);